
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"5","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.5 5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM2.5 14a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM2.5 23a2.5 2.5 0 100-5 2.5 2.5 0 000 5z","fill":"#008CB1"}})])
          )
        }
      }
    